
webpack.register(
    'components/live-brightcove-video/live-brightcove-video',
    function() {
        return require('components/live-brightcove-video/live-brightcove-video');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/live-brightcove-video/live-brightcove-video'/>\r\n\r\n<div class=\"c-live-player\">\r\n    <div class=\"c-live-player__close\" ($click)=\"ended()\">CLOSE</div>\r\n    {{#if liveVideoCard.video }}\r\n        <live-brightcove-video autoplay=\"true\" {youbora}=\"true\" {title}=\"title\" {video-id}=\"liveVideoCard.video.identifier\" (ended)=\"ended()\" (fullscreenchange)=\"onFullscreenChange\"/>\r\n    {{/if}}\r\n</div>");